import { useEffect } from "react";

interface UseDefaultValueAsProps {
  field: {
    defaultValueAs?: string;
    name: string;
    type: string;
  };
  setValue?: (name: string, value: any) => void;
  values?: { [key: string]: any };
}

const useDefaultValueAs = ({ field, setValue, values }: UseDefaultValueAsProps) => {
  useEffect(() => {
    const defaultValueAs = field.defaultValueAs;

    if (defaultValueAs) {
      setValue && setValue(field.name, values?.[defaultValueAs]);

      // If the field is a date type, set the month, day, and year separately for mobile date inputs
      if (field.type === "date") {
        const defaultDateValue = values?.[defaultValueAs];
        if (defaultDateValue && setValue) {
          setValue(`${field.name}-month`, values?.[`${defaultValueAs}-month`]);
          setValue(`${field.name}-day`, values?.[`${defaultValueAs}-day`]);
          setValue(`${field.name}-year`, values?.[`${defaultValueAs}-year`]);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field.defaultValueAs, setValue, field.name]);
};

export default useDefaultValueAs;
